// 字典表
import request from "@/utils/interceptor.js";

const dictionary = {
  getList(params) {
    let _params;
    if (typeof params === "string") {
      _params = {
        SkipCount: 0,
        MaxResultCount: 1000,
        Code: params,
      };
    } else {
      _params = params;
    }
    return request({ url: "/api/pas/dict-data", method: "get", params: _params });
  },
  // 新增
  add(data) {
    return request({ url: "/api/pas/dict-data", method: "post", data });
  },
  // 删除
  delete(id) {
    return request({ url: `/api/pas/dict-data/${id}`, method: "delete" });
  },
};

export default dictionary;
